/** Разбор /profile/:userId — только положительное число. */
export const parseProfileUserId = (raw: string | undefined): number | null => {
  if (!raw) return null;
  if (!/^\d+$/.test(raw)) return null;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const profileBasePath = (userId: number, selfId: number) =>
  userId === selfId ? '/profile' : `/profile/${userId}`;
